import React, { memo, useMemo } from "react";

import { DeviceScreenSizes } from "custom-types/DeviceScreenSizes";
import generateImageSrcProps from "utils/generateImageSrcProps";

import { ImageProps } from "./Image";

export const SCREEN_SIZES = [
  DeviceScreenSizes.Widescreen,
  DeviceScreenSizes.Desktop,
  DeviceScreenSizes.Tablet,
  DeviceScreenSizes.MobileMid,
  DeviceScreenSizes.Mobile,
];

type Props = Pick<
  ImageProps,
  "disableLazyLoad" | "mobileSrc" | "sizes" | "src" | "tabletSrc"
> & {
  params?: Record<string, string>;
};

export default memo(
  ({
    disableLazyLoad = false,
    mobileSrc,
    params,
    sizes,
    src,
    tabletSrc,
  }: Props) => {
    const srcProps = useMemo(
      () =>
        sizes
          .slice(0, 5)
          .map((size: number | null, i: number) => {
            if (size) {
              const url =
                i < 2 && mobileSrc
                  ? mobileSrc
                  : i === 2 && tabletSrc
                  ? tabletSrc
                  : src;
              return generateImageSrcProps(
                url,
                size,
                disableLazyLoad,
                params,
                true
              );
            } else {
              return null;
            }
          })
          .reverse(),
      [disableLazyLoad, mobileSrc, params, sizes.join(), src, tabletSrc]
    );

    return (
      <>
        {srcProps.map((srcProp: Record<string, string> | null, i: number) =>
          srcProp ? (
            <source
              {...srcProp}
              media={`(min-width: ${SCREEN_SIZES[i]}px)`}
              key={i}
            />
          ) : null
        )}
      </>
    );
  }
);
